import {SortOrder, TransitionState} from '../../shared/CommonInterfaces';
import {FilterKeys, FilterParams, PickWaveStatus} from './WaveBatchInterfaces';

export function filterParamsFromURLSearchParams(searchParams: URLSearchParams | null): FilterParams {
  if (!searchParams) return {};

  const params = {};
  searchParams.forEach((value, key) => {
    if (value && value.trim() !== '') {
      switch (key) {
        case FilterKeys.WaveId:
        case FilterKeys.ShipmentId:
        case FilterKeys.BatchId:
        case FilterKeys.Carrier:
        case FilterKeys.ServiceType:
        case FilterKeys.StagingLocation:
        case FilterKeys.Mhe:
        case FilterKeys.OrderReferenceId:
        case FilterKeys.LoadGroup:
        case FilterKeys.DestinationTag:
        case FilterKeys.ShipMode:
        case FilterKeys.PurchaseOrder:
          params[key] = value;
          break;
        case FilterKeys.ShipBy:
          params[key] = new Date(value);
          break;
        case FilterKeys.HidePrinted:
          params[key] = value === 'true';
          break;
        case FilterKeys.Status:
          params[key] = value === TransitionState.Active ? TransitionState.Active : PickWaveStatus[value];
          break;
        case FilterKeys.SortOrder:
          params[key] = value as SortOrder;
          break;
      }
    }
  });

  return params;
}
